import { usePatchMemberMemo } from '#api/member';
import { Text } from '#atoms';
import { Modal } from '#molecules';
import { useToast } from '#providers/ToastProvider';
import { useEffect, useState } from 'react';
import { ModalButton, ModalButtonContainer, ModalMemoField } from './styles';

interface CustomerMemoProps {
  setIsMemoModalOpen: (value: boolean) => void;
  memoResult: string;
  setMemoResult: (value: string) => void;
}
const CustomerMemo = ({
  setIsMemoModalOpen,
  memoResult,
  setMemoResult
}: CustomerMemoProps) => {
  const [memo, setMemo] = useState('');

  const personId = sessionStorage.getItem('personId');

  const { showToast } = useToast();

  const { mutate: patchMemo } = usePatchMemberMemo({
    onSuccess: () => {
      showToast({ type: 'success', message: '회원 메모가 수정되었습니다.' });
      setMemoResult(memo);
    },
    onError: () => {
      showToast({ type: 'fail', message: '회원 메모 수정에 실패했습니다.' });
    }
  });

  useEffect(() => {
    setMemo(memoResult);
  }, [memoResult]);

  const actionText = memoResult ? '수정' : '등록';

  const handleClick = () => {
    patchMemo({ personId: personId || '', memo });

    setIsMemoModalOpen(false);
  };

  return (
    <Modal
      style={{ padding: '24px' }}
      onClose={() => setIsMemoModalOpen(false)}
    >
      <div className="flex justify-between w-full">
        <Text textStyle="t3">회원 메모</Text>
      </div>{' '}
      <ModalMemoField
        placeholder="회원에 대해 메모할 내용을 적어주세요"
        value={memo}
        onChange={e => setMemo(e.target.value)}
      ></ModalMemoField>
      <ModalButtonContainer>
        <ModalButton onClick={() => setIsMemoModalOpen(false)}>
          취소
        </ModalButton>
        <ModalButton style={{ background: '#7750E9' }} onClick={handleClick}>
          {actionText}
        </ModalButton>
      </ModalButtonContainer>
    </Modal>
  );
};

export default CustomerMemo;
